import { Headphones, Menu } from "lucide-react";
import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
} from "@/components/ui/sheet";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { LANDING } from "@/constants/testIds";
import { LANGUAGES, t } from "@/lib/i18n";

// Top thin bar + main header (logo, desktop nav, language + admin/menu actions)
// and the mobile-menu sheet. Purely presentational — all state lives in the parent.
export default function SiteHeader({
  lang,
  setLang,
  logoUrl,
  navItems,
  scrollTo,
  mobileMenuOpen,
  setMobileMenuOpen,
  setContactOpen,
}) {
  const runNavItem = (it) => {
    if (it.onClick) it.onClick();
    else if (it.ref) scrollTo(it.ref);
  };

  return (
    <>
      {/* Top thin bar */}
      <div className="ddf-topbar" data-testid={LANDING.topbar}>
        <div className="ddf-topbar-inner">
          <div className="ddf-topbar-left">
            <button
              type="button"
              className="ddf-call"
              onClick={() => setContactOpen(true)}
              data-testid="topbar-contact-btn"
            >
              <Headphones size={14} /> {t(lang, "topbar_call")}
            </button>
          </div>
          <a
            href="https://www.dubaidutyfree.com"
            className="ddf-topbar-right"
            target="_blank"
            rel="noreferrer"
          >
            www.dubaidutyfree.com
          </a>
        </div>
      </div>

      {/* Main Header */}
      <header className="ddf-header" data-testid={LANDING.header}>
        <div className="ddf-header-inner">
          <div className="ddf-logo" data-testid={LANDING.logo}>
            {logoUrl ? (
              <img src={logoUrl} alt="Dubai Duty Free" data-testid={LANDING.logoImg} />
            ) : (
              <>
                <span className="ddf-logo-dubai">Dubai</span>
                <span className="ddf-logo-duty">Duty Free</span>
              </>
            )}
          </div>

          <nav className="ddf-nav ddf-nav-desktop">
            {navItems.map((it, i) => {
              const IconC = it.icon;
              return (
                <span key={it.key} className="ddf-nav-item">
                  <button
                    type="button"
                    className="ddf-nav-link"
                    data-testid={it.testId}
                    onClick={(e) => {
                      e.preventDefault();
                      runNavItem(it);
                    }}
                  >
                    {IconC && <IconC size={14} />}
                    {t(lang, it.key)}
                  </button>
                  {i < navItems.length - 1 && <span className="ddf-nav-sep">|</span>}
                </span>
              );
            })}
          </nav>

          <div className="ddf-header-actions">
            <Select value={lang} onValueChange={setLang}>
              <SelectTrigger className="ddf-lang-trigger" data-testid={LANDING.langSelect}>
                <SelectValue />
              </SelectTrigger>
              <SelectContent>
                {LANGUAGES.map((l) => (
                  <SelectItem key={l.code} value={l.code}>
                    {l.label}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
            <button
              className="ddf-mobile-menu-btn"
              onClick={() => setMobileMenuOpen(true)}
              aria-label="Menu"
              data-testid={LANDING.mobileMenuBtn}
            >
              <Menu size={22} />
            </button>
          </div>
        </div>
      </header>

      {/* Mobile Menu Sheet */}
      <Sheet open={mobileMenuOpen} onOpenChange={setMobileMenuOpen}>
        <SheetContent side="left" className="ddf-mobile-menu" data-testid={LANDING.mobileMenuSheet}>
          <SheetHeader>
            <SheetTitle>Dubai Duty Free</SheetTitle>
          </SheetHeader>
          <nav className="ddf-mobile-nav">
            {navItems.map((it) => (
              <button
                key={it.key}
                type="button"
                className="ddf-mobile-nav-link"
                data-testid={`mobile-nav-${it.key}`}
                onClick={() => runNavItem(it)}
              >
                {t(lang, it.key)}
              </button>
            ))}
          </nav>
        </SheetContent>
      </Sheet>
    </>
  );
}
